import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="py-16 px-6 bg-white" data-id="element-159">
      <div className="max-w-3xl mx-auto" data-id="element-160">
        <FadeIn data-id="element-161">
          <div className="relative p-8 md:p-12 border-l-4 border-terracotta bg-cream/30 rounded-r-2xl" data-id="element-162">
            <p className="font-serif text-xl md:text-2xl text-charcoal leading-relaxed mb-6" data-id="element-163">
              Estás frente al espejo. Aguantas la respiración. Intentas subir la
              cremallera de ese jean que siempre te quedaba bien, pero te
              detienes ante la presión en el abdomen. Sientes frustración,
              cansancio y una pregunta que se repite en tu cabeza:{' '}
              <span className="italic font-medium" data-id="element-164">
                "¿Por qué nada de lo que antes funcionaba está funcionando
                ahora?"
              </span>
            </p>
            <p className="font-sans text-lg text-charcoal/80 leading-relaxed" data-id="element-165">
              Has comido menos ensaladas y te has movido más, pero la balanza no
              cede y la inflamación parece haberse instalado permanentemente. No
              estás perdiendo el control, simplemente tu cuerpo ha cambiado las
              reglas del juego.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}